const DAWN_CART_ACTION_SOURCE = 'standard-actions';
let dawnCartActionQueue = Promise.resolve();

function collectCartSections() {
  const sections = [];
  const add = (id, selector, replaceElement = false) => {
    const mount = document.querySelector(selector);
    if (mount && id) sections.push({ id, selector, mount, replaceElement });
  };

  add('cart-drawer', 'cart-drawer');
  add('cart-icon-bubble', '#cart-icon-bubble');
  add(document.getElementById('main-cart-items')?.dataset.id, 'cart-items', true);
  add(document.getElementById('main-cart-footer')?.dataset.id, '#main-cart-footer', true);
  add('cart-live-region-text', '#cart-live-region-text');
  add('cart-notification-button', '#cart-notification-button');
  return sections;
}

async function fetchCartJSON(url) {
  const response = await fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store' });
  if (!response.ok) throw new Error(`Cart refresh returned ${response.status}`);
  return response.json();
}

async function refreshDawnCartUI() {
  const sections = collectCartSections();
  const cartUrl = (typeof routes !== 'undefined' && routes.cart_url) || `${window.Shopify?.routes?.root || '/'}cart`;
  const sectionIds = [...new Set(sections.map(({ id }) => id))];
  const requests = sectionIds.map(async (id) => {
    const response = await fetch(`${cartUrl}?section_id=${encodeURIComponent(id)}`, { cache: 'no-store' });
    if (!response.ok) throw new Error(`Cart section ${id} returned ${response.status}`);
    return [id, await response.text()];
  });
  const [cartData, ...responses] = await Promise.all([fetchCartJSON(`${cartUrl}.js`), ...requests]);
  if (!Array.isArray(cartData?.items) || !Number.isInteger(cartData.item_count)) {
    throw new Error('Cart refresh returned invalid cart data');
  }
  const sectionHTML = Object.fromEntries(responses);
  const replacements = sections.map((section) => {
    const html = sectionHTML[section.id];
    if (typeof html !== 'string' || !html.trim()) throw new Error(`Missing cart section: ${section.id}`);
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const source = parsed.querySelector(section.selector) || (
      ['cart-icon-bubble', 'cart-live-region-text', 'cart-notification-button'].includes(section.id)
        ? parsed.querySelector('.shopify-section') : null
    );
    if (!source) throw new Error(`Missing cart markup: ${section.selector}`);
    return { ...section, source };
  });

  const drawer = document.querySelector('cart-drawer');
  const drawerWasOpen = drawer?.classList.contains('active');
  const focusId = drawer?.contains(document.activeElement) ? document.activeElement.id : '';
  for (const { mount, source, replaceElement } of replacements) {
    if (replaceElement) mount.replaceWith(source);
    else mount.replaceChildren(...source.childNodes);
  }
  if (drawer) {
    drawer.classList.toggle('is-empty', cartData.item_count === 0);
    drawer.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => drawer.close());
    if (drawerWasOpen) {
      const inner = drawer.querySelector('.drawer__inner');
      const focusTarget = (focusId && drawer.querySelector(`#${CSS.escape(focusId)}`)) || inner;
      trapFocus(inner, focusTarget);
    }
  }
  await publish(PUB_SUB_EVENTS.cartUpdate, {
    source: DAWN_CART_ACTION_SOURCE,
    cartData: { ...cartData, sections: sectionHTML },
    cartSectionsRendered: true,
  });
}

function initStandardActions() {
  const actions = window.Shopify?.actions;
  if (!actions) return;
  actions.openCart.configure({
    async handler(defaultHandler) {
      const drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.open === 'function') {
        drawer.open(document.getElementById('cart-icon-bubble'));
        return;
      }
      return defaultHandler();
    },
  });
  actions.updateCart.configure({
    eventTarget: () => document,
    handler(defaultHandler) {
      const pending = dawnCartActionQueue.then(async () => {
        const result = await defaultHandler();
        try {
          await refreshDawnCartUI();
        } catch (error) {
          console.error('[Dawn] Standard Actions cart refresh failed; reloading.', error);
          window.location.reload();
        }
        return result;
      });
      dawnCartActionQueue = pending.catch(() => {});
      return pending;
    },
  });
}

if (window.Shopify?.actions) initStandardActions();
else document.addEventListener('DOMContentLoaded', initStandardActions, { once: true });
